import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/v1";

export interface IAdminNotification {
    id: number;
    title: string;
    description: string;
    type: number;
    category: string;
    reference_id: number;
    redirect_url: string | null;
    is_broadcast: boolean;
    is_read: boolean;
    sent_at: string;
    created_at: string;
    updated_at: string;
}

export interface AdminNotificationsResponse {
    status: boolean;
    message: string;
    data: IAdminNotification[];
    unreadCount: number;
}

export const getAdminNotifications = (): Promise<AdminNotificationsResponse> => {
    return axios.get(`${API_URL}/notifications/admin`);
};

export const markAsRead = (id: number) => {
    return axios.put(`${API_URL}/notifications/read/${id}`);
};
